import React, {useState, useEffect} from 'react';
import {Checkbox} from 'antd-mobile-v2';

export default function (props) {
  let defList = props.list.map(item => ({
    ...item,
    checked: false,
  }));
  const [arr, setArr] = useState([]);

  useEffect(() => {
    if (props.defList.tag && props.defList.tag.length) {
      props.defList.tag.forEach(tag => {
        defList.forEach((item, idx) => {
          if (item.val === tag || props.defList.tag.length === defList.length) {
            defList[idx].checked = true;
            if (item.remark === true) {
              const note = props.defList.note[0] || '';
              defList[idx].note = note;
            }
          }
        });
      });
    }
    setArr([...defList]);
  }, [props.list]);

  const onChange = (e, idx, remark) => {
    const checked = e.target.checked;
    if (props.multiple) {
      arr[idx].checked = checked;
    } else {
      arr.forEach(item => (item.checked = false));
      arr[idx].checked = checked;
    }

    setArr([...arr]);
    emitFn();
  };

  const emitFn = () => {
    const a = arr.filter(item => (item.remark ? item.checked && item.note : item.checked));
    props.onChange(a);
  };

  const onChangeNote = (data, idx) => {
    arr[idx] = data;
    emitFn();
  };

  return (
    <div className="ans-list">
      {arr.map((ans, a) => (
        <div className="ans" key={a}>
          {ans.remark ? (
            <CheckText def={ans} placeholder={ans.placeholder} change={val => onChangeNote(val, a)} />
          ) : (
            <Checkbox checked={ans.checked} onChange={e => onChange(e, a, ans.remark)}>
              <span className="check-label">{ans.val}</span>
            </Checkbox>
          )}
        </div>
      ))}
    </div>
  );
}

function CheckText({def, placeholder, change}) {
  const [data, setData] = useState({...def});

  useEffect(() => {
    change(data);
  }, [data]);

  const onChangeChk = e => {
    data.checked = e.target.checked;
    setData({...data});
  };

  const onFocus = e => {
    data.checked = true;
    setData({...data});
  };

  const onChangeTxt = e => {
    data.note = e.target.value;
    setData({...data});
  };

  return (
    <Checkbox checked={data.checked} onChange={onChangeChk}>
      <span className="check-label">{data.val}</span>
      {data.checked ? (
        <textarea
          className="remark"
          placeholder={placeholder ? placeholder : '请注明您的其他原因'}
          value={data.note}
          onFocus={onFocus}
          onChange={onChangeTxt}
        />
      ) : null}
    </Checkbox>
  );
}
